import { ToastController } from '@ionic/angular';

export let globalVariablesServer = {
  AppName: 'test',
   apiurl: 'https://www.mzhalehpour.com/',    // on Run Server
 //apiurl: 'https://localhost:44328/'
 //apiurl: 'http://localhost:8100/' //Run on Laptop
 
};


declare var $: any;

export let Toast = {
  presentToast(color, message) {
    const toast = this.toastCtrl.create({
      message: message,
      duration: 1500,
      // color: color,
      position: 'top'
      // icon: 'globe'
    });
    toast.present();
  }
};


